
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 13"}},[_c('rect',{attrs:{"x":"-.25","width":"150.25","height":"150.25","rx":"5","fill":"#414042"}}),_c('path',{attrs:{"d":"M72 18.88L9.23 127.56a5.56 5.56 0 004.82 8.35h125.49a5.56 5.56 0 004.82-8.35L81.62 18.88a5.57 5.57 0 00-9.62 0z","fill":"#eaf4f1","opacity":".8"}}),_c('path',{attrs:{"fill":"#fff","d":"M116.45 79.21l-78.32-1.73 2.06-3.55 68.29-8.53 7.97 13.81z"}}),_c('path',{attrs:{"fill":"#fff","d":"M40.19 73.93L0 87.81v2.79l38.13-13.12 2.06-3.55z"}}),_c('path',{attrs:{"fill":"#ed1c24","d":"M108.48 65.4L150 41.77v4.11L109.81 67.7l-1.33-2.3z"}}),_c('path',{attrs:{"fill":"#f7941d","d":"M150 45.88L109.81 67.7l1.46 2.55L150 49.72v-3.84z"}}),_c('path',{attrs:{"fill":"#fff200","d":"M150 49.72l-38.73 20.53 1.19 2.06L150 53.49v-3.77z"}}),_c('path',{attrs:{"fill":"#39b54a","d":"M112.46 72.31L150 53.49v3.98L114.02 75l-1.56-2.69z"}}),_c('path',{attrs:{"fill":"#00aeef","d":"M114.02 75l1.32 2.35L150 60.49v-3.02L114.02 75z"}}),_c('path',{attrs:{"fill":"#92278f","d":"M115.34 77.35l1.11 1.86L150 64.37v-3.88l-34.66 16.86z"}})])])
          )
        }
      }
    